//@flow
import * as React from 'react';
import { Text, Flex, Columns, Column, Stack } from '@locus-taxy/neo-ui';
import TeamChip from 'common/components/core/common/TeamChip';
import { type TFunction } from 'react-i18next';

import pjpPlansTestIds from 'common/tests/masterManagement/pjpPlans.json';

type Props = {
    planName: ?string,
    team: string,
    theme: ThemeType,
    onExportClick: () => void,
    t: TFunction
};

export default class PjpInsightsHeader extends React.PureComponent<Props> {
    render() {
        const { planName, team, theme } = this.props;
        return (
            <Columns alignY="center" className={theme.insightsHeader}>
                <Column>
                    <Stack space="tiny">
                        {planName ? (
                            <Flex>
                                <Text
                                    className={theme.divider}
                                    fontSize={2}
                                    fontWeight="medium"
                                >
                                    •
                                </Text>
                                <Text
                                    fontSize={2}
                                    fontWeight="medium"
                                    data-test-id={
                                        pjpPlansTestIds.insights.planName
                                    }
                                >
                                    {planName}
                                </Text>
                            </Flex>
                        ) : null}

                        <TeamChip
                            invert={false}
                            team={team}
                            key={team.teamId}
                            id={team.teamId}
                        />
                    </Stack>
                </Column>
            </Columns>
        );
    }
}
